import { pushToDataLayer } from '@domain-group/fe-helper';
import { sendToMixpanel, getUserProps } from '..';
import { getVisibleLandingPageModules } from './modules';
import type { FaaLandingPageModule } from './modules';

interface TrackContentCarouselCtaOptions {
  carouselName: string;
  carouselTitle: string;
  interactionCTA: string;
  modules?: FaaLandingPageModule[];
}

const trackContentCarouselCta = ({
  carouselName,
  carouselTitle,
  interactionCTA,
  modules = getVisibleLandingPageModules(),
}: TrackContentCarouselCtaOptions): void => {
  sendToMixpanel('Tap Content Carousel Header CTA', {
    siteSection: 'Agents',
    carouselName,
    carouselTitle,
    interactionCTA,
    modules,
    modulesCount: modules.length,
    ...getUserProps(),
  });

  pushToDataLayer({
    event: 'cta_driver',
    element_list_name: carouselName,
    element_title: carouselTitle,
    element_text: interactionCTA,
    element_list_position: '',
    element_target_category_primary: 'Content',
    element_target_page_type: 'Index',
    element_type: 'text link',
  });
};

export default trackContentCarouselCta;
